import { useCallback } from "react";
import toast, { Toast, ToastBar, Toaster } from "react-hot-toast";

import { ContactPanelTabIds } from "@hd/contact-panel/types/contact-panel-tab-ids";
import { useContactPanel } from "@hd/contact-panel/useContactPanel";

function ToastWrapper() {
  // const { setOpen } = useNotificationsStore();

  const { open } = useContactPanel();

  const dimissToast = useCallback(
    (t: Toast) => {
      toast.dismiss(t.id);

      if (t.className?.includes("notification-toast")) {
        const [companyId, contactId] = t.id.split("-").map(Number);
        open(contactId, companyId, ContactPanelTabIds.CONVERSATION);
      }
    },
    [open]
  );
  return (
    <Toaster>
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <div
              className="flex text-center w-full items-center text-sm px-3"
              onClick={(e) => {
                e.stopPropagation();
                dimissToast(t);
              }}
            >
              {icon}
              {message}
            </div>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}

export default ToastWrapper;
